import { useVendorsContext } from "@/pages/configurations/vendors/context/VendorsContext";
import { Vendor } from "@/pages/configurations/vendors/models/Vendor";
import {
	cellActionsStyle,
	rowButtonStyle,
	rowIconButtonStyle,
} from "@/utils/ag-grid-defaults";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useMemo } from "react";
import { usePartsContext } from "../../../context/PartsContext";

type Props = {
	/*  gridRef:Function, */
	setModalEditPart: Function;
	setModalComponentType: Function;
	setModalDeletePart: Function;
	setPartIdForEdit: Function;
	setPartIdForDelete: Function;
};

export const useTableData = ({
	setPartIdForEdit,
	setModalEditPart,
	setPartIdForDelete,
	setModalDeletePart,
	setModalComponentType,
}: Props) => {
	const {
		state: { parts },
	} = usePartsContext();
	const {
		state: { vendors },
	} = useVendorsContext();

	const columns: ColDef[] = [
		{
			field: "partId",
			headerName: "#",
			// width: 100,
			flex: 1,
			filter: "agSetColumnFilter",
		},
		{
			field: "partName",
			headerName: "Name",
			flex: 3,
		},
		{
			field: "componentTypes",
			headerName: "Component Types",

			cellRenderer: (params: any) => {
				return (
					<span style={cellActionsStyle}>
						<Button
							variant="outlined"
							color="primary"
							size="small"
							style={rowButtonStyle}
							onClick={() => {
								(async () => {
									setPartIdForEdit(params.data.partId);
									setModalComponentType(true);
								})();
							}}
						>
							Components
						</Button>
					</span>
				);
			},
			sortable: false,
			flex: 2,
		},
		{
			field: "isActive",
			headerName: "Status",
			flex: 1,
		},
		{
			field: "description",
			headerName: "Description",
			flex: 3,
		},
		{
			field: "sku",
			headerName: "SKU",
			flex: 1,
		},
		{
			field: "unit",
			headerName: "Unit",
			flex: 1,
		},
		{
			field: "vendorId",
			headerName: "Vendor",
			flex: 2,
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<span style={cellActionsStyle}>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setPartIdForEdit(params.data.partId);
								setModalEditPart(true);
							}}
						>
							<EditIcon style={{ width: 18, height: 18 }} color="primary" />
						</Button>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setPartIdForDelete(params.data.partId);
								setModalDeletePart(true);
							}}
						>
							<DeleteIcon style={{ width: 18, height: 18 }} color="secondary" />
						</Button>
					</span>
				);
			},
			headerName: " ",
			sortable: false,
			flex: 1,
		},
	];

	const defaultColDef = useMemo(
		() => ({
			resizable: true,
			sortable: true,
			filter: true,
			suppressMenu: true,
		}),
		[],
	);

	const rows = parts.map(
		({
			partId,
			partName,
			description,
			sku,
			unit,
			vendorId,
			actualArrival,
			isActive,
		}) => {
			const vendor: Vendor | undefined = find(vendors, ["vendorId", vendorId]);

			return {
				partId,
				partName,
				description,
				sku,
				unit,
				vendorId: vendor?.vendorName,
				actualArrival,
				isActive: isActive ? "Active" : "Inactive",
				id: partId,
			};
		},
	);
	return { rows, columns, defaultColDef };
};
